import React, {Fragment} from "react";
import image from '../../../images/situation/nkozijnen/aantalKozijnen.jpg'

export default function Kozijnen(props) {
    return <Fragment>
        <div className="addtextMore">
            Hier kunt u invullen hoeveel kozijnen deze specifieke situatie bevat.<br/>
        </div>
        <img className="explainImage" src={image} alt=""/>
    </Fragment>;
}